<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="reservationsTable">
  <p-table #pt [value]="reservations" [paginator]="true" [rows]="30" [rowsPerPageOptions]="[30, 50,100,200]"
    [totalRecords]="recordTotal" [lazy]="true" (onLazyLoad)="loadLazy($event)" sortMode="multiple"  [multiSortMeta]="multiSortMeta"
    selectionMode="single" [globalFilterFields]="['propertyCode', 'reservationId', 'guestLastName', 'reservationStatus']"
    [filterDelay]="1000" [(selection)]=" reservation" dataKey="reservationId" (onRowSelect)="onRowSelect($event)" showCurrentPageReport="true"
    [loading]="loading" [responsive]="true" styleClass="p-datatable-striped" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"  showJumpToPageInput="true">

    <ng-template pTemplate="caption">
      <div class="flex">
      </div>
      <div class="row m-0">
        <div [formGroup]="form1" class="forms d-block">
          <div class="col-lg-12 d-flex pl-0">
            <span class="p-float-label my-2 me-2 mt-2 d-block">
              <!-- <p-iconField iconPosition="left" class="ml-auto position-relative">
              <p-inputIcon>
                <span class="p-input-icon">
                  <i class="pi pi-search"></i>
                </span>
              </p-inputIcon>
              <input
                formControlName="globalFilter"
                pInputText
                type="text"
                (input)="pt.filterGlobal($event.target.value, 'contains')"
                placeholder="Search keyword" />
            </p-iconField>-->
          </span>

          <!--            <span class="p-float-label my-2 me-2">
          <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
            [options]="shortTermRentals" formControlName="shortTermRentalIds" defaultLabel="Select Property"
            dataKey="shortTermRentalId" id="shortTermRentalIds" optionLabel="propertyCode" display="chip"
            appendTo="body">
          </p-multiSelect>
        </span>
        <span class="p-float-label my-2 me-2">
          <p-calendar inputId="startDate" formControlName="startDate" (onSelect)="onDateChange()" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="startDate">Start-Date</label>
        </span>
        <span class="p-float-label my-2 me-2">
          <p-calendar #endDate inputId="endDate" formControlName="endDate" [style]="{'width':'200px'}"
            appendTo="body" [minDate]="minDate" [defaultDate]="minDate">
          </p-calendar>
          <label for="startDate">End-Date</label>
        </span>
        <span class="p-float-label my-2 me-2">
          <button pButton class="btn-addt p-button" (click)="search()">Search</button>
        </span>
        <span class="p-float-label my-2 me-2">
          <button pButton class="btn-addt p-button" (click)="clearForm()">Clear</button>
        </span>-->
      </div>
    </div>
  </div>
  <div [formGroup]="form1" class="forms d-block">
    <div class="row m-0">
      <div class="col-lg-12 d-flex pl-0">
        <span class="p-float-label my-2 me-2">
          <p-iconField iconPosition="left" class="ml-auto position-relative">
            <p-inputIcon>
              <span class="p-input-icon">
                <i class="pi pi-search"></i>
              </span>
            </p-inputIcon>
            <input
              formControlName="globalFilter"
              pInputText
              type="text"
              (input)="pt.filterGlobal($event.target.value, 'contains')"
              placeholder="Search keyword" />
          </p-iconField>
        </span>
        <span class="p-float-label my-2 me-2 mt-2 d-block">
          <p-multiSelect autoWidth="false" [scrollHeight]="'50vh'"
            [options]="shortTermRentals" formControlName="shortTermRentalIds" defaultLabel="Select Property"
            dataKey="shortTermRentalId" id="shortTermRentalIds" optionLabel="propertyCode" display="chip"
            [maxSelectedLabels]="3" styleClass="w-full md:w-80"
            appendTo="body">
          </p-multiSelect>
          <label for="shortTermRentalIds">Select Property</label>
        </span>
        <span class="p-float-label my-2 me-2">
          <p-calendar inputId="startDate" formControlName="startDate" (onSelect)="onDateChange()" [style]="{'width':'200px'}"
            appendTo="body">
          </p-calendar>
          <label for="startDate">Start-Date</label>
        </span>
        <span class="p-float-label my-2 me-2">
          <p-calendar #endDate inputId="endDate" formControlName="endDate" [style]="{'width':'200px'}"
            appendTo="body" [minDate]="minDate" [defaultDate]="minDate">
          </p-calendar>
          <label for="endDate">End-Date</label>
        </span>
        <div class="btn-group">
          <div class="button-group">
            <button pButton class="btn-addt p-button" (click)="search()">Search</button>
          </div>
        </div>

        <!--  <app-import-export importEnabled="false" [dataRetrived]="reservations" (exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true"></app-import-export>
        -->
      </div>
    </div>
  </div>
</ng-template>
<ng-template pTemplate="header">
  <tr>

    <th [pSortableColumn]="'reservationVO.reservationStatus'">Status
      <p-sortIcon [field]=""></p-sortIcon>
    </th>
    <th [pSortableColumn]="'createDate'">Created
      <p-sortIcon [field]=""></p-sortIcon>
    </th>

    <th [pSortableColumn]="'reservationVO.shortTermRentalVO.propertyCode'">Unit
      <p-sortIcon [field]="'reservationVO.shortTermRentalVO.propertyCode'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'reservationVO.guestProfileVO.lastName'">Name
      <p-sortIcon [field]="'reservationVO.guestProfileVO.lastName'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'reservationVO.orderVO.orderId'">OrderId
      <p-sortIcon [field]="'reservationVO.orderVO.orderId'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'reservationVO.reservationId'">ReservationId
      <p-sortIcon [field]="'reservationVO.reservationId'"></p-sortIcon>
    </th>
    <th pSortableColumn="reservationVO.checkInDateTime">In
      <p-sortIcon field="reservationVO.checkInDateTime"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'reservationVO.checkOutDateTime'">Out
      <p-sortIcon [field]="'reservationVO.checkOutDateTime'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'paymentReceived'">Payment Received
      <p-sortIcon [field]=""></p-sortIcon>
    </th>
    <!--<th [pSortableColumn]="'invoiceSubTotal'">SubTotal
    <p-sortIcon [field]=""></p-sortIcon>
  </th>
  <th [pSortableColumn]="'invoiceTax'">Tax
    <p-sortIcon [field]=""></p-sortIcon>
  </th>-->
  <th [pSortableColumn]="'invoiceTotal'">Total
    <p-sortIcon [field]=""></p-sortIcon>
  </th>
  <!--        <th [pSortableColumn]="'invoiceDiscount'">Discount(-)
  <p-sortIcon [field]=""></p-sortIcon>
</th>
<th [pSortableColumn]="'invoiceOriginalTotal'">Org. Total
  <p-sortIcon [field]=""></p-sortIcon>
</th>-->
<!--				<th [pSortableColumn]="'ledgerCreditTotal'">Ledger(+)
<p-sortIcon [field]=""></p-sortIcon>
</th>
<th [pSortableColumn]="'ledgerDebitTotal'">Ledger(-)
  <p-sortIcon [field]=""></p-sortIcon>
</th>-->
<th [pSortableColumn]="'ledgerTotal'">Ledger Total
  <p-sortIcon [field]=""></p-sortIcon>
</th>
<!--        <th [pSortableColumn]="'nightlyRateSubTotal'">Nightly Rate
<p-sortIcon [field]=""></p-sortIcon>
</th>-->
<th [pSortableColumn]="'ledgerTotal'">Net Revenue
  <p-sortIcon [field]=""></p-sortIcon>
</th>
<th [pSortableColumn]="'kbmMistakeAmount'">KBM Mistake
  <p-sortIcon [field]=""></p-sortIcon>
</th>

<th></th>
<th>Balance?
</th>
<th>Actions
</th>

<th>Channel
</th>
</tr>
<tr>
  <th>
    <p-multiSelect [options]="constantService.reservationStatuses" defaultLabel="Status"
    (onChange)="pt.filter($event.value, 'reservationVO.reservationStatus', 'in')" appendTo="body"></p-multiSelect>
  </th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
  (input)="pt.filter($event.target.value, 'createDate', 'in')"></th>
  <th>
    <input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'reservationVO.shortTermRentalVO.propertyCode', 'startsWith')">
  </th>
  <th>
    <input pInputText style="width:150px;" type="text"
      (input)="pt.filter($event.target.value, 'reservationVO.guestProfileVO.lastName', 'startsWith')">
  </th>
  <th>
    <input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'reservationVO.orderVO.orderId', 'in')">
  </th>
  <th>
    <input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'reservationVO.reservationId', 'in')">
  </th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
  (input)="pt.filter($event.target.value, 'reservationVO.checkInDateTime', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
  (input)="pt.filter($event.target.value, 'reservationVO.checkOutDateTime', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <!-- <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>-->
  <th></th>
  <th>
    <p-columnFilter type="boolean" field="locked"
    (input)="pt.filter($event.target.value, 'locked', 'in')" ></p-columnFilter> </th>
    <th>
      <p-columnFilter type="boolean" field="balanced"
      (input)="pt.filter($event.target.value, 'balanced', 'in')" ></p-columnFilter> </th>

      <th></th>
      <th>
        <p-multiSelect [options]="constantService.refSrcImages" defaultLabel="Channel"
        (onChange)="pt.filter($event.value, 'reservationVO.orderVO.referralSourceId', 'in')" appendTo="body"></p-multiSelect>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-reservation>
    <tr [pSelectableRow]="reservation">
      <td [style.background-color]="getResStatusColor(reservation.reservationStatus)">
      {{getResStatusName(reservation.reservationStatus)}}</td>

      <td>{{reservation.createDate|date:'MM/dd/yy'}}</td>
      <td>{{reservation.propertyCode}}</td>
      <td><b>{{reservation.guestLastName}}</b></td>
      <td style="color:blue;" (click)="openOrder(reservation)"><b>{{reservation.orderId}}</b></td>
      <td><b>{{reservation.reservationId}}</b></td>

      <td style="white-space: nowrap;">{{reservation.checkInDate|date:'MM/dd/yy EEEEEE'}}</td>
      <td style="white-space: nowrap;">{{reservation.checkOutDate|date:'MM/dd/yy EEEEEE'}}</td>
      <td >{{reservation?.paymentReceived | currency : 'USD'}}</td>

      <!--        <td >{{reservation?.invoiceSubTotal | currency : 'USD'}}</td>
      <td >{{reservation?.invoiceTax | currency : 'USD'}}</td>-->
      <td >{{reservation?.invoiceTotal | currency : 'USD'}}</td>
      <!-- <td >{{reservation?.invoiceDiscount | currency : 'USD'}}</td>

      <td >{{reservation?.invoiceOriginalTotal | currency : 'USD'}}</td>-->
      <!--   <td >{{reservation?.ledgerCreditTotal | currency : 'USD'}}</td>
      <td >{{reservation?.ledgerDebitTotal | currency : 'USD'}}</td>-->
      <td >{{reservation?.ledgerTotal | currency : 'USD'}}</td>

      <!-- <td >{{reservation?.nightlyRateSubTotal | currency : 'USD'}}</td>-->
      <td >{{reservation?.netRevenueAmount | currency : 'USD'}}</td>
      <td >{{reservation?.kbmMistakeAmount | currency : 'USD'}}</td>
      <td>
        <i class="pi {{reservation?.locked ? 'pi-lock' : 'pi-lock-open'}}" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"></i>
      </td>
      <td [style.background-color]="getSyncColor(reservation)">{{getDiscripancyAmt(reservation)}}</td>
      <td>
        <span style="float:none">
          <a>
            <i class="pi pi-info-circle" title="Invoice" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="openInvoice(reservation)"></i>
          </a>
        </span>
        <span style="float:none">
          <a>
            <i class="pi pi-book" title="Ledger" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="openLedger(reservation)"></i>
          </a>
        </span>
        <span style="float:none">
          <a>
            <i class="pi pi-replay" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="generateLedgers(reservation)" title="ReGenerateLedger"></i>
          </a></span>
        </td>
        <td><img style='height: 23px; width: 80px' src='{{constantService.getChannelPictureURL(reservation.referralSourceId)}}'/></td>
      </tr>
    </ng-template>
    <ng-template pTemplate=" paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
      {{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
    lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
  </p-table>
</div>
